"use client";
import { memo, useEffect, useRef } from "react";
import { cn } from "utils";
import { stickyConfig } from "../stickyConfig";
import { useListData } from "./useListData";
import { TokenCard } from "./TokenCard";
import createInfiniteScroll from "./createInfiniteScroll";

export const TokenCarousel: React.FC = () => {
  const { data } = useListData();

  const wrapperRef = useRef<HTMLDivElement>(null);
  const contentRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (data && data?.length > 0) {
      const wrapper = wrapperRef.current!;
      const content = contentRef.current!;

      if (!content || !wrapper) {
        return;
      }
      const infiniteScroll = createInfiniteScroll({
        scrollTrack: content,
        scrollContainer: wrapper,
        cardWidth: 232, // 200px (TokenCard宽度) + 33px (分隔线及其边距)
        duration: 5,
      });
      return () => {
        infiniteScroll.destroy();
      };
    }
  }, [data]);

  return (
    data.length > 0 && (
      <div
        className={cn(
          "relative before:content-[''] before:absolute before:left-0 before:w-[76px] before:h-9 before:bg-gradient-to-l before:from-transparent before:to-[#0F0F0F]",
          " after:content-[''] after:absolute after:top-0 after:w-[76px] after:h-9 after:bg-gradient-to-l after:from-transparent after:to-[#0F0F0F]",
          " after:rotate-180 after:right-0",
        )}
        style={{
          height: stickyConfig.KolStatusHeight,
        }}
      >
        <div
          className={cn(
            "flex-1 overflow-x-auto no-scrollbar h-[fit-content] pr-28",
          )}
          ref={wrapperRef}
        >
          <div
            ref={contentRef}
            className="flex justify-start w-[fit-content] items-center"
          >
            {data?.map((item, index) => (
              <MemoizedTokenCarousel
                key={`${item?.id || ""}-${item?.name || ""}-${index}`}
                token={item?.symbol || ""}
                icon={item?.socials?.image_url || ""}
                price={item?.trade?.price_change_24h || ""}
                id={item?.id || ""}
              />
            ))}
          </div>
        </div>
      </div>
    )
  );
};

const MemoizedTokenCard = memo(TokenCard);

export const MemoizedTokenCarousel = memo(MemoizedTokenCard);
